export default __webpack_public_path__ + "static/avatar-mp-kayi-male-0-v3-be51c5365341fee68d245def7a8592af.png";